import type { ExcelGridHeaderRowProps } from "../models/excel-grid-component-props.models";
import { ExcelGridColumnHeaderControl } from "./ExcelGridColumnHeaderControl";

export const ExcelGridHeaderRow = ({
  columns,
  dataTest,
  filters,
  sortState,
  hasFilters,
  onClearFilters,
  onFilterChange,
  onSortToggle,
}: ExcelGridHeaderRowProps) => (
  <tr>
    {columns.map((column) => (
      <th
        key={column.key}
        scope="col"
        data-test={`${dataTest}-header-${column.key}`}
        className="border-greyscale-20 border-b border-r p-1.5 align-bottom dark:border-gray-700"
      >
        <ExcelGridColumnHeaderControl
          column={column}
          dataTest={dataTest}
          filterValue={filters[column.key] ?? ""}
          sortState={sortState}
          onClearFilters={onClearFilters}
          onFilterChange={onFilterChange}
          onSortToggle={onSortToggle}
          hasFilters={hasFilters}
        />
      </th>
    ))}
  </tr>
);
